// extracted by mini-css-extract-plugin
export default {"container":"users-deleted_page_container__RNr24","headerContainer":"users-deleted_page_headerContainer__vXiF5"};